export const removeHTMLfromString = (htmlString: string) => {
  //remove html and nonbreaking spaces, ampersands and å
  return htmlString
    .replace(/<[^>]*>?/gm, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&aring;/g, "å")
    .replace(/&Aring;/g, "Å")
    .replace(/&ouml;/g, "ö")
    .replace(/&Ouml;/g, "Ö")
    .replace(/&auml;/g, "ä")
    .replace(/&Auml;/g, "Ä")
    .replace(/&ndash;/g, "-");
};

export const isFirstLetterUpperCase = (string: string) => {
  return string.charAt(0) === string.charAt(0).toUpperCase();
};

export const capitalizeFirstLetter = (string: string) => {
  if (string.length === 0) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const insertDashIntoSsn = (ssn: string): string => {
  if (ssn && ssn.length === 12) {
    return `${ssn.substring(0, 8)}-${ssn.substring(8)}`;
  }
  return ssn;
};
